import { Card, Input, Select, Row, Col } from "antd";
import { usePicklists } from "components/picklists/PicklistContextProvider";

interface DictationFilterProps {
  selectedProviders?: string[];
  selectedReportTypes?: string[];
  selectedJobId?: string;
  onProviderChange: (value: string[] | undefined) => void;
  onReportTypeChange: (value: string[] | undefined) => void;
  onJobIdChange: (value: string) => void;
}

const DictationFilter = ({
  selectedProviders = [],
  selectedReportTypes = [],
  selectedJobId = "",
  onProviderChange,
  onReportTypeChange,
  onJobIdChange
}: DictationFilterProps) => {
  const { providers, documentTypes } = usePicklists();

  return (
    <Card
      styles={{ body: {padding: "16px"} }} 
      className={`service-filter-card`}>
      <span className="dictation-filter-title">
        Dictation
      </span>
      <Row gutter={[8,12]} style={{ marginTop: '10px' }} justify={'space-between'}>
        <Col xs={24} sm={12}>
          <label htmlFor="provider" className="input-label">
            Provider
          </label>
          <Select
            id="provider"
            mode="multiple"
            variant="borderless"
            allowClear
            value={selectedProviders}
            onChange={onProviderChange}
            className="dictation-filter-select"
            placeholder="Please select provider"
            maxTagCount="responsive"
            showSearch
            filterOption={(input, option) =>
              option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {providers?.sort((a, b) => a.providerName.localeCompare(b.providerName)).map(provider => (
              <Select.Option key={provider.providerId} value={provider.providerId}>
                {provider.providerName}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12}>
          <label htmlFor="report-type" className="input-label">
            Report Type
          </label>
          <Select
            id="report-type"
            variant="borderless"
            mode="multiple"
            allowClear
            value={selectedReportTypes}
            onChange={onReportTypeChange}
            className="dictation-filter-select"
            placeholder="Please select report type"
            maxTagCount="responsive"
            showSearch
            filterOption={(input, option) =>
              option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            >
            {documentTypes?.map(documentType => (
              <Select.Option key={documentType.documentTypeId} value={documentType.documentTypeName}>
                {documentType.documentTypeName}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12}>
          <label htmlFor="jobId" className="input-label">
            Job#
          </label>
          <Input
            id="jobId"
            value={selectedJobId}
            onChange={(e) => onJobIdChange(e.target.value)}
            className="filter-input"
            placeholder="Job Number"
          />
        </Col>
      </Row>
    </Card>
  );
};

export default DictationFilter;
